import { useEffect, useState } from 'react';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

export default ({
  fetchVersions,
  getComposeSchema,
  getPropertiesAxiosConfig,
  getPropertiesSchema,
  getVersionAxiosConfig,
  onVersionContent,
  version,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isVersioning, setIsVersioning] = useState(false);
  const [composeSchema, setComposeSchema] = useState({});
  const [model, setModel] = useState({});
  const [propertiesSchema, setPropertiesSchema] = useState([]);

  const fetchVersion = async (data) => {
    try {
      const fetchedModel = (await axios(getPropertiesAxiosConfig(data))).data.data;

      setModel(fetchedModel);
      setPropertiesSchema(getPropertiesSchema(fetchedModel));
      setComposeSchema(getComposeSchema(fetchedModel));
    } catch (error) {
      handleAxiosError(error);
    }

    setIsLoading(false);
  };

  const versionContent = async () => {
    setIsVersioning(true);

    try {
      const { data: { data } } = await axios(getVersionAxiosConfig(model));

      await fetchVersion({ id: data.published_course_id });
      fetchVersions();
      onVersionContent();
    } catch (error) {
      handleAxiosError(error);
    }

    setIsVersioning(false);
  };

  useEffect(() => { fetchVersion(version); }, []);

  return {
    composeSchema,
    fetchVersion,
    isLoading,
    isVersioning,
    model,
    propertiesSchema,
    versionContent,
  };
};
